import { Injectable } from '@angular/core';
import 'rxjs/add/observable/of';
import { BaseService } from './base.service';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Global } from 'app/@core/lib/global';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class ClienteService extends BaseService {

    constructor(
        public http: HttpClient,
        public global: Global,
        public router: Router,
        public auth: AuthService
    ) {
        super(http);
    }

    public getForms(): Observable<any> {
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-user/form', { headers: this.getHeader() });
    }

    public getAdressByCep(cep: string): Observable<any> {
        const headerOptions = {
            'Content-Type': 'application/x-www-form-urlencoded',
        };
        return this.http.get('http://viacep.com.br/ws/' + cep + '/json/', { headers: new HttpHeaders(headerOptions) });
    }

    public searchClient(fields, values, page) {
        let data = {
            fields: fields,
            values: values
        }

        return this.http.post(this.baseUrl + '/api/v21/admin/asap-client/pesquisa?page=' + page, data, { headers: this.getHeader('application/json') });
    }

    public getClienteData(idCliente: number = null): Observable<any> {
        if (idCliente !== null) {
            return this.http.get(this.baseUrl + '/api/v2/admin/asap-client/' + idCliente, { headers: this.getHeader() });
        }
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-client', { headers: this.getHeader() });
    }

    public getGroup(idCliente: number): Observable<any> {
        return this.http.get(this.baseUrl + '/api/v2/admin/asap-client/vinculo/' + idCliente, { headers: this.getHeader() });
    }

    public group(company_id, clients_id): Observable<any> {
        let data = {
            company_id: company_id,
            clients_id: clients_id.join(",")
        };
        let header = this.getHeader("application/json");
        return this.http.post(this.baseUrl + '/api/v2/admin/asap-client/vinculo', data, { headers: header });
    }

    public ungroup(company_id, client_id): Observable<any> {
        return this.http.delete(this.baseUrl + '/api/v2/admin/asap-client/vinculo/' + company_id + '/' + client_id, { headers: this.getHeader() });
    }

    public switch(to) {
        return this.http.get(this.baseUrl + '/api/switch/' + to, { headers: this.getHeader() });
    }

    public saveData(data: any, idCliente = null): Observable<any> {
        const headerOptions = {
            'Authorization': sessionStorage.getItem('token'),
            'Accept': 'application/json'
        };
        if (idCliente === null) {
            return this.http.post(this.baseUrl + '/api/v2/admin/asap-client/store',
                data,
                { headers: new HttpHeaders(headerOptions) });
        }
        return this.http.put(this.baseUrl + '/api/v2/admin/asap-client/' + idCliente + '/update',
            data,
            { headers: new HttpHeaders(headerOptions) });
    }

    public doSwitch(client) {
        this.global.loading = true;
        this.switch(client).subscribe((response: any) => {
            if (response.token) {
                this.auth.setSessionToken(response).then(res => {
                    if (res) {
                        window.location.href = "/dashboard";
                        //window.location.href = window.location.href;
                    } else {
                        //this.errorNotificate('Você não tem permissão para acessar esse recurso.');
                        this.router.navigate(['/erros/403']);
                    }
                }).catch(err => {
                    console.log(err);
                });
            }
        });

    }

    public changePassword(id, password) {
        let data = {
            user_id: id,
            password: password
        }
        return this.http.put(this.baseUrl + '/api/v2/perfil/sobre', data, { headers: this.getHeader('application/json') });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/cliente.service.ts